import DocumentsCEController from './documents.ce.controller';

export default {
    template: require('./documents.ce.tpl.html'),
    controller: DocumentsCEController
};
